import UsersService from '../../../services/users.service';
import { Capacitor } from '@capacitor/core';

export default {
    name: 'PromotionBanner',
    props: {
        config: {
            type: Object,
            required: true
        }
    },

    methods: {
        ctaProps(cta) {
            if (cta.type === 'external') {
                return {
                    href: cta.href,
                    target: '_blank',
                    rel: 'noopener'
                };
            }

            return {
                to: cta.to
            };
        },

        linkProps(link) {
            if (link.type === 'external') {
                return {
                    href: link.href,
                    target: '_blank',
                    rel: 'noopener'
                };
            }

            return {
                to: link.to
            };
        },

        async goToTaxDown() {
            try {
                this.$store.dispatch('showLoading');
                const getTaxDownUrlRes = await UsersService.getTaxDownUrl();
                this.$store.dispatch('hideLoading');
                const taxDownUrl = getTaxDownUrlRes.data.tax_down_url;

                if (Capacitor.isNativePlatform()) {
                    let inAppBrowserOptions = 'location=no, beforeload=yes';
                    if (Capacitor.getPlatform() === 'android') {
                        inAppBrowserOptions += ',zoom=no';
                    }
                    window.cordova.InAppBrowser.open(
                        encodeURI(taxDownUrl),
                        '_blank',
                        inAppBrowserOptions
                    );
                } else {
                    const newTab = window.open(taxDownUrl, '_blank');
                    if (newTab) {
                        newTab.focus();
                    } else {
                        console.warn('El navegador bloqueó la apertura de la nueva ventana');
                    }
                }
            } catch (error) {
                console.error(error);
                this.$bvToast.toast(`${error.message}`, {
                    title: 'Error',
                    toaster: 'b-toaster-top-center',
                    autoHideDelay: 10000,
                    variant: 'danger'
                });
            } finally {
                this.$store.dispatch('hideLoading');
            }
        }
    }
};
